module.exports = __webpack_public_path__ + "static/img/PrideFlagSmall.ab76bae0.jpg";